import { storageApi } from "apis/storageApi";

export const FORM_IDS = {
  CREATE: "create-product-form",
  EDIT: "edit-product-form",
  DELETE: "delete-product-form",
};

export const PRODUCT_IMAGE_FOLDER = "products";
export const PRODUCT_IMAGE_MAX_SIZE = 5 * 1024 * 1024;
export const PRODUCT_IMAGE_ALLOWED_TYPES = ["image/png", "image/jpeg", "image/webp"];
export const PRODUCT_IMAGE_ACCEPT = PRODUCT_IMAGE_ALLOWED_TYPES.join(",");

export function validateProductImageFile(file: File): string | null {
  if (!PRODUCT_IMAGE_ALLOWED_TYPES.includes(file.type)) {
    return "Chỉ chấp nhận ảnh PNG, JPEG hoặc WebP";
  }
  if (file.size > PRODUCT_IMAGE_MAX_SIZE) {
    return "Ảnh không được vượt quá 5MB";
  }
  return null;
}

export async function uploadProductImage(file: File): Promise<string> {
  const res = await storageApi.uploadFile(file, PRODUCT_IMAGE_FOLDER);
  if (!res.data?.success) throw new Error("Upload thất bại");
  return res.data.data.key as string;
}
